import { Col, Flex, Input, Row, Space } from "antd";
import { Field, Form, Formik } from "formik";
import { Translation, useTranslation } from "react-i18next";
import { isPassword } from "utils/validators";
import * as Yup from "yup";


import Logo from "assets/images/logo_final_1_1.png";
import { Button } from "components/elements";
import { AuthBackground } from "components/layouts";
import { initialValues } from "../schemas/changePasswordSchema";

import styles from "../styles/ChangePassword.module.css";

const ChangePassword = ({
  isLoading = false,
  doChangePassword = () => { },
  onCancel = () => { },
}) => {
  const { t } = useTranslation();
    function matchColorText(bool) {
    return !bool ? 'grey' : 'black'
  }

  function matchColorDot(bool) {
    return !bool ? 'grey' : '#2CADE7'
  }

  const PasswordSchema = Yup.string()
    .min(8, t("change_password.at_leat_8"))
    .test("is-password", t("change_password.password_invalid"), (value) => isPassword(value));

  const ChangePasswordSchema = Yup.object().shape({
    oldPassword: PasswordSchema.required(t("change_password.old_password_is_at")),
    newPassword: PasswordSchema.required(t("change_password.new_password_is_at")).notOneOf(
      [Yup.ref("oldPassword"), null],
      t("change_password.is_same")
    ),
    newPasswordConfirm: Yup.string()
      .required(t("change_password.new_password_confirm"))
      .oneOf([Yup.ref("newPassword"), null], t("change_password.must_match")),
  });


  return (
    <AuthBackground showLanguageSwitcher>
      <div className={styles.container}>
        <img src={Logo} className={styles.logo} alt="flow hr logo" />
        <p className={styles.header}>
          <Translation>{(t) => t("change_password.header")}</Translation>
        </p>
        {/* <p className={styles.subHeader}>
          <Translation>{(t) => t("change_password.sub_Header").split("\n")
            .map((line, index) => <span key={index}>{line}<br /></span>)}</Translation>
        </p> */}
        <Formik
          initialValues={initialValues}
          onSubmit={doChangePassword}
          validationSchema={ChangePasswordSchema}
        >
          {({ isValid, values }) => {
            return (
              <Form className={styles.formContainer}>
                <Field name="oldPassword">
                  {({ field, meta }) => (
                    <div>
                      <Input.Password
                        size="large"
                        type="text"
                        placeholder={t("change_password.oldPassword")}
                        className={styles.input}
                        status={meta.touched && meta.error ? "error" : ""}
                        {...field}
                      />
                      {meta.touched && meta.error && (
                        <div className="error">{meta.error}</div>
                      )}
                    </div>
                  )}
                </Field>
                <Field name="newPassword">
                  {({ field, meta }) => (
                    <div>
                      <Input.Password
                        size="large"
                        type="text"
                        placeholder={t("change_password.newPassword")}
                        className={styles.input}
                        status={meta.touched && meta.error ? "error" : ""}
                        {...field}
                      />
                      {meta.touched && meta.error && (
                        <div className="error">{meta.error}</div>
                      )}
                    </div>
                  )}
                </Field>

                <Field name="newPasswordConfirm">
                  {({ field, meta }) => (
                    <div>
                      <Input.Password
                        size="large"
                        type="text"
                        placeholder={t("change_password.newPasswordConfirm")}
                        className={styles.input}
                        status={meta.touched && meta.error ? "error" : ""}
                        {...field}
                      />
                      {meta.touched && meta.error && (
                        <div className="error">{meta.error}</div>
                      )}
                    </div>
                  )}
                </Field>
                <Flex>
                  <Row gutter={10} justify={"space-between"} >
                    <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.match("(?=.*[A-Z])")) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.match("(?=.*[A-Z])")) }}></div>{t("common.capital_pass")}</Space></Col>
                    <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.match("(?=.*[a-z])")) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.match("(?=.*[a-z])")) }}></div>{t("common.lower_pass")}</Space></Col>
                    <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.match("(?=.*[0-9])")) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.match("(?=.*[0-9])")) }}></div>{t("common.number_pass")}</Space></Col>
                    <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.length >= 8) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.length >= 8) }}></div>{t("common.at least_8")}</Space></Col>
                    <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.match("(?=.*[^a-zA-Z0-9_])")) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.match("(?=.*[^a-zA-Z0-9_])")) }}></div>{t("common.special_char")}</Space></Col>
                    {/* <Col span={12}><Space styles={{ item: { fontSize: '10px', color: matchColorText(values?.newPassword?.length > 0 && values?.newPasswordConfirm?.length > 0 && values?.newPassword == values?.newPasswordConfirm) } }}><div style={{ borderRadius: "50%", width: "10px", height: "10px", backgroundColor: matchColorDot(values?.newPassword?.length > 0 && values?.newPasswordConfirm?.length > 0 && values?.newPassword == values?.newPasswordConfirm) }}></div>รหัสผ่านไม่ตรงกัน</Space></Col> */}
                  </Row>

                </Flex>

                <Button
                  className={styles.button}
                  size="large"
                  htmlType="submit"
                  disabled={isLoading || !isValid}
                >
                  <p className={styles.textbuttonConfirm}>{t("common.confirm").toUpperCase()}</p>
                </Button>
                <Button
                  className={styles.buttonCancel}
                  // type="default"
                  size="large"
                  htmlType="button"
                  onClick={onCancel}
                >
                  <p className={styles.textbuttonCancel}>{t("common.cancel").toUpperCase()}</p>
                </Button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </AuthBackground>
  );
};

export default ChangePassword;
